import { useCallback, useState } from 'react';
import api from 'api';
import { API_SCORECARD_KEY_REVIEWER } from 'constants/api';
import { generateURL } from 'helpers';
import { useScorecardContext } from 'contexts';
import useScorecardUpdate from './useScorecardUpdate';

export default function useKeyReviewer() {
  const [updatingKeyReviewer, setUpdatingKeyReviewer] = useState(false);
  const { id } = useScorecardContext();
  const { updateData } = useScorecardUpdate();

  const setKeyReviewer = useCallback(
    async (goalId: number, userId: number, isKeyReviewer: boolean) => {
      setUpdatingKeyReviewer(true);

      return api.axios
        .patch(generateURL(API_SCORECARD_KEY_REVIEWER, { id, goalId }), {
          userId,
          isKeyReviewer,
        })
        .then(() => {
          updateData();
        })
        .finally(() => {
          setUpdatingKeyReviewer(false);
        });
    },
    [id, updateData],
  );

  const toggleKeyReviewer = useCallback(
    async (goalId: number, userId: number, currentIsKeyReviewer: boolean) =>
      setKeyReviewer(goalId, userId, !currentIsKeyReviewer),
    [setKeyReviewer],
  );

  return {
    updatingKeyReviewer,
    setKeyReviewer,
    toggleKeyReviewer,
  };
}
